import { useContext, useEffect, useState } from 'react';
import { BreadcrumbContext } from '../../Layout/Layout';
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import { getStateName } from '../../../atoms/StatesDropdown/states';
import CountryDropdown from '../../../atoms/CountryDropdown';
import { viewEditLocation, deleteLocation } from '../../Locations/Locations/locationsUtilities';
import { getPassholdersCountFromPassLocations } from '../../../utilities/pass';

function ViewLocations() {
  const { setCurrentBreadcrumb } = useContext(BreadcrumbContext);
  const selectedCust = JSON.parse(localStorage.getItem('selectedCustomer') || null);
  const selectedCustomerId = localStorage.getItem('selectedCustomerId');
  const [selectedCustomer, setSelectedCustomer] = useState(selectedCust);
  const countries = useSelector(state => state.appData.countries);
  const classifiedPassholders = useSelector(state => state.passholder.classifiedPassholders) || JSON.parse(sessionStorage.getItem('classifiedPassholders'));
  const { sitE_NAME, sitE_ID, locations } = JSON.parse(localStorage.getItem('selectedSite') || {});
  const [selectedSite, setSelectedSite] = useState(sitE_NAME);
  const [locationsData, setLocationsData] = useState(locations?.length ? [...locations] : []);
  const navigate = useNavigate();

  const updateBreadcrumb = (customeR_FIRSTNAME) => {
    setCurrentBreadcrumb([
      {
        "linkText": "All Customers",
        "path": "/customers"
      },
      {
        "linkText": customeR_FIRSTNAME || '-',
        "path": "/customers/view"
      },
      {
        "linkText": selectedSite,
        "path": "/customers/view/locations"
      }
    ]);
  };

  const getCustomerData = async () => {
    if(!selectedCustomerId) {
      navigate('/customers');
    };

    try {
      const response = await axios.request({
          baseURL: 'https://passeazy-api.azurewebsites.net/api',
          url: `/GetCustomerById/${selectedCustomerId}`,
          method: 'get',
      });
      updateBreadcrumb(response?.data?.customeR_FIRSTNAME)
      setSelectedCustomer(response?.data);
    }
    catch(e) {
      toast('Something went wrong, please try again later.')
    }
  };

  const getSelectedCountryName = (countryCode) => {
    const selectedCountry =  countries.filter(country => country.countrY_ID === countryCode);
    return selectedCountry[0]?.nicename || '';
  }

  useEffect(() => {
    selectedCust && updateBreadcrumb(selectedCust.customeR_FIRSTNAME);
    !selectedCust && getCustomerData();
  }, []);

  const viewPasses = (selectedLocation, passesCount) => {
    if(!passesCount) {
      toast('No passes are currently present under this site.');
      return;
    }
    localStorage.setItem('selectedLocation', JSON.stringify(selectedLocation));
    navigate('/passes');
  }

  const renderSiteDetails = () => locationsData.map((location, locationindex) => (
    <div className="view-locations-site" key={`location${locationindex}`}>
      <div className="view-locations-site-info-container">
        <div className="view-locations-site-info">
          <div className="view-locations-site-label">Location-{locationindex+1}</div>
          <div className="view-locations-site-value">{location.locatioN_NAME}</div>
        </div>

        <div className="view-locations-site-card">
          <div className="view-locations-site-label">
            Passes
            <div className="view-locations-site-value">{getPassholdersCountFromPassLocations([location], classifiedPassholders)}</div>
          </div>
          <div className="view-locations-site-btn">
            <button onClick={() => viewPasses(location, getPassholdersCountFromPassLocations([location], classifiedPassholders))}>
              <img src="/assets/customers/view/view.png"/>
            </button>
          </div>
        </div>
      </div>

      <div className="view-locations-site-actions">
        <button onClick={() => viewEditLocation('edit', { ...location, sitE_ID}, navigate)}>
          <img src="/assets/customers/view/edit.png"/>
        </button>

        <button onClick={() => deleteLocation(location, getCustomerData)}>
          <img src="/assets/customers/view/delete.png"/>
        </button>
      </div>
    </div>
  ));

  return (
    <div className="view-locations">
      <div className="view-locations-details">
        <div className="view-locations-details-img">
          <img id="previewImg" src={selectedCustomer?.logO_IMAGE ? `data:image/jpeg;base64,${selectedCustomer?.logO_IMAGE}` : "/assets/customers/default-pic.png"}/>
        </div>
        <div className="view-locations-details-info">
          <div className="view-locations-details-info1">
            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Customer Name
              </div>
              <div className="view-locations-details-info-value">
                {selectedCustomer?.customeR_FIRSTNAME}
              </div>
            </div>

            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Email
              </div>
              <div className="view-locations-details-info-value">
                {selectedCustomer?.customeR_EMAIL}
              </div>
            </div>

            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Phone
              </div>
              <div className="view-locations-details-info-value">
                {selectedCustomer?.phonE_NUMBER}
              </div>
            </div>
            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Website
              </div>
              <div className="view-locations-details-info-value">
                {selectedCustomer?.websitE_URL}
              </div>
            </div>
          </div>
          <div className="view-locations-details-info2">
            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Address
              </div>
              <div className="view-locations-details-info-value">
                {selectedCustomer?.addresS_LINE1}
              </div>
            </div>
            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                State
              </div>
              <div className="view-locations-details-info-value">
                {getStateName(selectedCustomer?.statE_ID)?.statE_NAME}
              </div>
            </div>
            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Country
              </div>
              <div className="view-locations-details-info-value">
                {getSelectedCountryName(selectedCustomer?.countrY_ID)}
              </div>
            </div>
          </div>
          <div className="view-locations-details-info3">
            <div className="view-locations-details-info-row">
              <div className="view-locations-details-info-label">
                Notes
              </div>
              <div className="view-locations-details-info-value view-locations-details-info-value-notes">
                {selectedCustomer?.notes}
              </div>
            </div>
            <div className='view-locations-details-link' onClick={() => navigate('/customers/edit')}>View more</div>
          </div>
        </div>
      </div>

      <div className="view-locations-sites">
        <div className="view-locations-heading">{selectedSite}</div>
        { locationsData?.length ? renderSiteDetails() : (
          <div className="view-locations-site">
            <div className="view-locations-site-info-container" style={{color: 'white'}}>No location records found</div>
          </div>
        )}
      </div>
      <CountryDropdown  displayDropdown={false}/>
    </div>
  )
};

export default ViewLocations;